import { create } from 'zustand';

/**
 * Shared signal for scrolling to and highlighting newly created folders and items.
 *
 * Writers: FolderSecurityDialog (folders), creation dialogs per entity (items).
 * Readers: every FolderItemList-based list/grid component.
 */
interface FolderItemScrollState {
  newFolderId: string | null;
  requestScrollToNewFolder: (id: string) => void;
  clearNewFolderId: (id: string) => void;
  /** IDs of all items to highlight. Hook scrolls to the topmost (min row index).
   *  Single create: one element. Batch upload: all uploaded files. */
  newItemIds: readonly string[];
  requestScrollToNewItems: (ids: string[]) => void;
  clearNewItemIds: (id: string) => void;
}

export const useFolderItemScrollStore = create<FolderItemScrollState>((set) => ({
  newFolderId: null,
  requestScrollToNewFolder: (id) => set({ newFolderId: id }),
  clearNewFolderId: (id) => set((s) => (s.newFolderId === id ? { newFolderId: null } : s)),
  newItemIds: [],
  requestScrollToNewItems: (ids) => set({ newItemIds: ids }),
  clearNewItemIds: (id) => set((s) => (s.newItemIds.includes(id) ? { newItemIds: [] } : s)),
}));
